export default {
  allUserTypes: state => {
    return state.userTypes;
  },

  rowsTable: state => {
    return [10, 50, 100, "Tout"];
  }, 

  paymentUserTypes: state => {
    return {
      'super_administrator_sys': 'Super Administrateur',
      'administrator_sys': 'Administrateur',
      'gestionnaire_sys': "Gestionnaire",
      'medical_advisor_sys': "Médecin-Conseil",
      'client': 'Client', 
      'broker_inspector': 'Inspecteur',
      'broker_leader': "Chef d'équipe",
      'broker_merchant': 'Commercial',
      'broker_general_agent': 'Agent général',
      'broker': 'Courtier',
      'prospect': 'Prospect',
      'none': "Aucun",
    }
  },
  
  identityList: state => {
    return [
      { id: "cni", label: "Carte Nationale d'identité" },
      { id: "passeport", label: "Passeport" },
    ];
  },
  allProduct: state => {
    return [
      { id: "ABQ", label: "Atlantique Bouclier Quiétude" },
      { id: "APF", label: "Atlantique Prévoyance Familiale" },
      { id: "AHR", label: "Atlantique Horizon Retraite" },
      { id: "AAE", label: "Atlantique Avenir Enfant" },
      { id: "AAF", label: "Atlantique Assistance Funérailles" },
    ];
  },

  brokerOwn(state) {
    return state.brokerOwn
  },

  allStatusOngoing: state => {
    return [
      { id: "quote", label: "Devis" },
      { id: "notTerminate", label: "Non finalisé" },
      { id: "projetNotOk", label: "Sans suite" }
    ]
  },

  allCategorySocioPro: state => {
    return [
      { id: "insuranceAgent", label: "Agent assurance" },
      { id: "executive", label: "Cadre" },
      { id: "entrepreneur", label: "Chef entreprise" },
      { id: "jobSeeker", label: "Demandeur emploi" },
      { id: "employee", label: "Employé" },
      { id: "student", label: "Etudiant" },
      { id: "official", label: "Fonctionnaire" },
      { id: "companyManager", label: "Gérant de société" },
      { id: "worker", label: "Ouvrier" },
      {
        id: "medicalAndParamedicalProfessionsNotEmployees",
        label: "Professions médicales et paramédicales Non Salariés"
      },
      {
        id: "medicalAndParamedicalProfessionsEmployees",
        label: "Professions médicales et paramédicales Salariés"
      },
      { id: "nonSalariedWorker", label: "Travailleur Non Salarié" },
      { id: "retirement", label: "Retraité" },
      { id: "noOccupation", label: "Sans profession" }
    ];
  },

  familySituation: state => {
    return [
      { id: "single", label: "Célibataire" },
      { id: "concubine", label: "Concubin(e)" },
      { id: "divorced", label: "Divorcé(e)" },
      { id: "widower", label: "Veuf(ve)" },
      { id: "married", label: "Marié(e)" },
      { id: "pacse", label: "Pacsé(e)" }
    ];
  },

  canalList: state => {
    return [
      { id: "client", label: "Direct" },
      { id: "broker", label: "Intermédiaire" },
      { id: "offline", label: "Admin" }
    ];
  },

  noticeList: state => {
    return [
      { id: "fullInfo", label: "Informations complémentaires" },
      { id: "medicalVisit", label: "Visite médicale" },
      { id: "standardValidation", label: "Validation standard" },
      { id: "validationWithExtraPremium", label: "Validation avec surprime" },
      { id: "rejection", label: "Rejet" },

    ];
  },

  stateList: state => {
    return [
      { id: "toStudy", label: "A étudier" },
      { id: "fullInfo", label: "Info Compl" },
      { id: "medicalVisit", label: "Visite médicale" }
    ];
  },

  subscriptionNotice: state => {
    return [
      { id: "rejection", label: "Rejet" },
      { id: "standardValidation", label: "Validation standard" },
      { id: "validationWithExtraPremium", label: "Validation avec surprime" }
    ];
  },

  allContratStatus: state => {
    return [
      { id: "none", label: "" },
      { id: "active", label: "Actif" },
      { id: "inactive", label: "Inactif" },
      { id: "pendingInactive", label: "Bientôt Inactif" }
    ];
  },

  paymentMethod: state => {
    return [
      { id: "bankCard", label: "Carte bancaire" },
      { id: "check", label: "Chèque" },
      { id: "cash", label: "Espèces" }, 
      { id: "commercialGesture", label: "Geste commercial" },
      { id: "momoCard", label: "Mobile money" },
      { id: "debitAuto", label: "Prélèvement automatique" },
      { id: "virementBank", label: "Virement" },
      { id: "InternalTransfer", label: "Virement interne" }
    ];
  },

  allPaymentStatus: state => {
    return [
      { id: "late", label: "En retard" },
      { id: "required", label: "Non soldé" },
      { id: "payOff", label: "Soldé" }];
  },

  allUserAcces: state => {
    return {
      chk_administrators: false,
      chk_intermediary: false,
      chk_customer_client: false,
      chk_project_pending: false,
      chk_subscription: false,
      chk_mailing: false,
      chk_mail_client: false,
      chk_slip: false,
      chk_customer_docs: false,
      chk_ticket: false,
      chk_policy: false,

      isDisableAdministrators: false,
      isDisableIntermediary: false,
      isDisableCustomerClient: false,
      isDisableProjectPending: false,
      isDisableSubscription: false,
      isDisableMailing: false,
      isDisableMailClient: false,
      isDisableSlip: false,
      isDisableCustomer_docs: false,
      isDisableTicket: false,
      isDisablePolicy: false,
    }
  },

  allMailVariableText: state => {
    let allVariable = "";
    state.allVariableList.forEach(el => {
      allVariable += ` ${el.id}`;
    });
    return `Veuillez utiliser ${allVariable} comme variable dynamique`;
  },

  allMailVariableList: state => {
    return state.allVariableList;
  },

  allTyeMailAdditionalInfoForIntermediary: (state) => {
    return {
      ABQ: "admin_Setting_MailAdditionalInfoForIntermediary_atlantiqueBouclierQuiétude",
      APF: "admin_Setting_MailAdditionalInfoForIntermediary_atlantiquePrévoyanceFamille",
      AHR: "admin_Setting_MailAdditionalInfoForIntermediary_atlantiqueHorizonRetraite",
      AAE: "admin_Setting_MailAdditionalInfoForIntermediary_atlantiqueAvenirEnfant",
      AAF: "admin_Setting_MailAdditionalInfoForIntermediary_atlantiqueAssistanceFunérailles",
    }
  },

  allDocClient: (state) => {
    return {
      ABQ: "admin_Setting_DocClient_atlantiqueBouclierQuiétude",
      APF: "admin_Setting_DocClient_atlantiquePrévoyanceFamille",
      AHR: "admin_Setting_DocClient_atlantiqueHorizonRetraite",
      AAE: "admin_Setting_DocClient_atlantiqueAvenirEnfant",
      AAF: "admin_Setting_DocClient_atlantiqueAssistanceFunérailles",
    }
  }, 

  allPeriodicityOfPayment: (state) => {
    return [
      { id: "monthly", label: "Mensuelle" },
      { id: "quarterly", label: "Trimestrielle" },
      { id: "biannual", label: "Semestrielle" },
      { id: "annual", label: "Annuelle" },
    ]
  },

  allPeriodicityOfPaymentValue: (state) => {
    return [
      { id: "monthly", value: 12 },
      { id: "quarterly", value: 4 },
      { id: "biannual", value: 2 },
      { id: "annual", value: 1 },
    ]
  },

  productNature: (state) => {
    return [
      { id: "ABQ", label: "PRÉVOYANCE" },
      { id: "AAF", label: "PRÉVOYANCE" },
      { id: "APF", label: "PRÉVOYANCE" },
      { id: "AHR", label: "RETRAITE" },
      { id: "AAE", label: "ÉTUDES" },
    ]
  },
  
};
